// Libraries & Utils
import Immutable from 'seamless-immutable';
import {TReducers} from 'library/redux';
import createReduxSauce from 'library/redux/createReduxSauce';

// Types
import {IActionCreators, IActionTypes, IState, ISelector} from './types';


/** -----------------------------------------
 Store Key
 /** ---------------------------------------*/
export const storeKey = 'trade';


/** -----------------------------------------
 Initial State
 /** ---------------------------------------*/
export const InitialState = Immutable<IState>({
    isFetching: false,
    message: '',

    tradeHistory: [],
    tradeHistoryPagination: {
        totalItems: 0,
        totalPages: 0,
        currentPage: 0,
        pageLimit: 0,
    },
});

/** -----------------------------------------
 Selectors
 /** --------------------------------------*/
export const Selector: ISelector = {};



/** -----------------------------------------
 Reducers
 /** ---------------------------------------*/
const Reducers: TReducers<IActionCreators ,IState> = {
    /**
     * 取得交易紀錄清單
     */
    fetchTradeHistory: (state) => {
        return state;
    },
    fetchTradeHistoryBegin: (state) => {
        return state.merge({isFetching: true, message: '正在讀取交易紀錄清單'});
    },
    fetchTradeHistorySuccess: (state, {payload}) => {
        return state.merge({isFetching: false, message: '', tradeHistory: payload.tradeHistory, tradeHistoryPagination: payload.tradeHistoryPagination});
    },
    fetchTradeHistoryFail: (state, {payload}) => {
        return state.merge({isFetching: false, message: ''});
    },
};


export const {Reducer, Actions, ActionTypes} = createReduxSauce<IActionTypes, IActionCreators, IState>(storeKey, InitialState, Reducers);
